module.exports = __webpack_public_path__ + "static/media/AW_250-Mama_mobile_hero_en.aff5feb6.jpg";